import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { listPartners, normalizePartnersListResponse } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const usePartnersQuery = (params = {}, options = {}) =>
  useQuery({
    queryKey: partnerQueryKeys.list(params),
    queryFn: async () => {
      const result = await listPartners(params);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch partners');
      }
      return normalizePartnersListResponse(result.data, params);
    },
    placeholderData: keepPreviousData,
    ...options,
  });
